import { render, staticRenderFns } from "./watch-solid.vue?vue&type=template&id=b99a40d2&"
import script from "./watch-solid.vue?vue&type=script&lang=js&"
export * from "./watch-solid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports